import AddLessons from './AddLessons';

export default AddLessons;
